module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h14"
  }, [_vm._v("Remerciements")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('img', {
    attrs: {
      "alt": "img2.png",
      "height": "132",
      "src": "images/img2.png",
      "width": "441"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Merci comme toujours à mon super groupe de soutien – Alex, Dottie et Chudney. Un merci tout particulier à Dolorianne qui m’a sauvée sur celui-là.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Je dois également remercier le Centre de Soutien de Vol d’Identité Canadien, et particulièrement Heather, qui a été d’une aide très précieuse et a répondu à toutes mes questions. Si quoi que ce soit devait être incorrect, c’est entièrement ma faute. ")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0d7b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0